module.exports = __webpack_public_path__ + "static/media/symbol_icon.vertex.db662b1b.glsl";